import useSWR, { mutate } from 'swr'

import { TenantConfig } from '../../data/models'
import { Constants } from '../constants'

export { TenantContainer } from './components/TenantContainer'

function keyUrlStartsWith(key: unknown, value: string): boolean {
  if (Array.isArray(key)) {
    return (key[0] as string).toLowerCase().startsWith(value.toLowerCase())
  }

  if (typeof key === 'string') {
    return key.toLowerCase().startsWith(value.toLowerCase())
  }

  return false
}

function mutateConfig() {
  mutate((key: unknown) => keyUrlStartsWith(key, '/config'))
}

function mutateBusinessObjects() {
  mutate((key: string) => key.toLowerCase() === '/orderresponses')
  mutate((key: string) => key.toLowerCase() === '/despatchadvices')
  mutate((key: string) => key.toLowerCase() === '/invoices')
}

function mutateTenantQueries() {
  mutate('tenantconfig')
  mutate((key: unknown) => keyUrlStartsWith(key, '/permissions'))
  // mutate((key: unknown) => keyUrlStartsWith(key, '/selfservices'))
  mutate((key: unknown) => keyUrlStartsWith(key, '/tenants'))
  mutate((key: unknown) => keyUrlStartsWith(key, '/tenantfiles'))
}

function mutateAll() {
  mutateConfig()
  mutateTenantQueries()
  mutateBusinessObjects()
}

export function setCurrentTenantConfig(tenantConfig: TenantConfig): void {
  localStorage.setItem(Constants.TenantConfig, JSON.stringify(tenantConfig))
  mutateAll()
}

export function unsetCurrentTenantConfig(): boolean {
  localStorage.removeItem(Constants.TenantConfig)
  mutateAll()
  return true
}

export function getCurrentTenantConfig(): TenantConfig | undefined {
  const result = localStorage.getItem(Constants.TenantConfig)
  if (!result) return undefined

  const config: TenantConfig = JSON.parse(result as string) as TenantConfig
  return config
}

export function useCurrentTenantConfig(): TenantConfig {
  const { data } = useSWR('tenantconfig', getCurrentTenantConfig)
  return data ? data : { tenantId: '', projectId: '' }
}
